import { fade } from './theme/fade.theme';
import { slideFade } from './theme/slideFade.theme';
import { slideLeft } from './theme/slideLeft.theme';
import { slideRight } from './theme/slideRight.theme';
import { slideUp } from './theme/slideUp.theme';
import { slideDown } from './theme/slideDown.theme';
import { slideDownUp } from './theme/slideDownUp.theme';
import { slideInOut } from './theme/slideInOut.theme';
import { slideOutIn } from './theme/slideOutIn.theme';

export const animationTheme = {
  fade,
  slideFade,
  slideLeft,
  slideRight,
  slideUp,
  slideDown,
  slideDownUp,
  slideInOut,
  slideOutIn,
};
